import React from 'react';
import { Link } from 'react-router-dom';

const VoiceOfFarmersMain = () => {
  const cardData = [
    {
      image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744235851/image_ai2noe.png',
      title: 'Planning & management',
      location: 'Walvis Bay, Namibia',
      link: 'Voice1',
    },
    {
      image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744235861/image-1_wkkcij.png',
      title: 'Market',
      link: 'Voice2',
    },
    {
      image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744235869/image-2_uuqx5g.png',
      title: 'Productivity',
      link: 'Voice3',
    },
    {
      image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744239433/image-3_lss5jw.png',
      title: 'Planning & management',
      link: 'Voice4',
    },
    {
      image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744239433/image-4_rhdunv.png',
      title: 'Market',
      link: 'Voice5',
    },
    {
      image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744239433/image-5_pnfckj.png',
      title: 'Productivity',
      link: 'Voice6',
    },
    {
      image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744323550/image_hlcl7g.png',
      title: 'Planning & management',
      link: 'Voice7', // Unique link for the seventh card
    },
    {
      image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744323537/image-1_tz2vdi.png',
      title: 'Market',
      link: 'Voice8', // Unique link for the eighth card
    },
    {
      image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744323537/image-2_rl49yz.png',
      title: 'Productivity',
      link: 'Voice9', // Unique link for the ninth card
    },
    {
      image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744323538/image-3_hbt2m7.png',
      title: 'Planning & management',
      link: 'Voice10', // Unique link for the tenth card
    },
    {
      image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744323539/image-4_mhehvs.png',
      title: 'Market',
      link: 'Voice11', // Unique link for the eleventh card
    },
    {
      image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744323538/image-5_on6sur.png',
      title: 'Productivity',
      link: 'Voice12', // Unique link for the twelfth card
    },
  ];

  return (
    <div className="px-4 md:px-20 py-5 bg-white">
   <div className='flex justify-between items-center'>
   <h2 className="text-[24px] md:text-[36px] font-bold text-[#FDBD26] md:mt-5">Voice of Farmer</h2>
      <img
                        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744287925/Expand_down_hlf9gz.png"
                        alt="icon"
                        className="w-6 h-6 md:w-8 md:h-8 md:flex hidden"
                    />
                      <img
                        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744418512/Expand_down_tylfdw.png"
                        alt="icon"
                        className="w-6 h-6 md:w-8 md:h-8 md:hidden flex"
                    /> 
   </div>
      {/* Grid Layout */}
      <div className="grid grid-cols-3 sm:grid-cols-3 lg:grid-cols-3 md:gap-6 gap-2 md:mt-10 mt-4">
        {cardData.map((card, index) => (
          <Link to={`/${card.link}`} key={index}> {/* Link directly to the card link */}
            <div
              className="h-[150px] md:h-[600px] md:rounded-2xl rounded-md relative overflow-hidden bg-cover bg-center"
              style={{ backgroundImage: `url(${card.image})` }}
            >
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743776596/image_1502_utmsek.png"
                alt="Play"
                className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[40px] h-[40px] md:w-[100px] md:h-[100px] z-10"
              />
              <div className="absolute md:bottom-0 bottom-0 md:left-0 w-full md:p-4 p-1.5">
                <h3 className="text-[8px] md:text-[22px] font-bold text-white px-2">{card.title}</h3>
                <p className="text-[4px] md:text-[18px] font-normal text-white px-2">
                  Farmnet has improved my productivity by linking me with service providers & resources
                </p>
                <div className="flex items-center justify-between px-2 mt-2">
                  <div className="flex items-center gap-2">
                    <img
                      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744235659/image_20_ujukab.png"
                      alt="Location"
                      className="md:w-5 md:h-5 w-3 h-3"
                    />
                    <p className="text-white text-[6px] md:text-[14px] font-medium flex">
                      <strong className="font-medium md:flex hidden">Walvis bay, </strong>Namibia
                    </p>
                  </div>
                  <img
                    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744205132/Expand_right_unwap6.png"
                    alt="Person"
                    className="md:w-8 h-3 w-3 md:h-8"
                  />
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
      <div className="md:h-5"></div>
    </div>
  );
};

export default VoiceOfFarmersMain;
